import { DeleteConfirmationModal } from 'components/core-ui/DeleteConfirmationModal'

export const DeleteModal = ({ isModalOpen, closeModal, itemId, setShouldRefreshData }) => (
  <DeleteConfirmationModal
    isModalOpen={isModalOpen}
    actionUrl="/iam/management-tools/jobs/:id"
    content="Are you sure you want to deactivate this job? This action cannot be undone."
    closeModal={closeModal}
    itemId={itemId}
    setShouldRefreshData={setShouldRefreshData}
    succesMessage="Job deactivated successfully"
  />
)